import _forEach from 'lodash/forEach';

const getSelectedId = (relationships, parameterName) => {
  const selectedParameter = relationships[`${parameterName}_selected`];
  let parameterId = null;

  if (selectedParameter && selectedParameter.data && selectedParameter.data.id) {
    parameterId = selectedParameter.data.id;
  }

  return parameterId;
};

const convertPreAvailable = (preAvailable, parameters) => {
  const available = {};

  _forEach(preAvailable, (el, key) => {
    if (!available[key]) {
      available[key] = [];
    }

    _forEach(el, (el1) => {
      available[key].push({
        id: el1.id,
        attributes: parameters[key][el1.id]
      });
    });
  });

  return available;
};

export const colors = [
  'gates_color',
  'roof_color',
  'roofing_color',
  'tooling_color',
  'roof_tooling_color',
  'gutters_color',
  'walls_color',
  'doors_front_color',
  'doors_back_color',
  'doors_left_color',
  'doors_right_color'
];

// ✅ helper: wyciąga value z różnych formatów
const pickValue = (item) =>
  item?.value ??
  item?.attributes?.value ??
  item?.attributes?.value_cm ??
  null;

// ✅ helper: czy relacja to "*_available"
const isAvailableRelationshipKey = (k) => typeof k === 'string' && k.endsWith('_available');

const convertCalculationResponse = (data) => {
  const parameters = {};
  const preAvailable = {};
  const selected = {};
  const info = {};
  const subtypes = {};
  let newData = {};

  data.included.forEach((el) => {
    if (!parameters[el.type]) {
      parameters[el.type] = {};
    }
    parameters[el.type][el.id] = el.attributes;

    if (!selected[el.type]) {
      selected[el.type] = getSelectedId(data.relationships, el.type);
    }

    const preAvailableItem = data.relationships[`${el.type}_available`];

    if (el.subtype) {
      if (!subtypes[el.subtype]) {
        subtypes[el.subtype] = [];
      }

      if (!subtypes[el.subtype].find((el1) => el1.id === el.id)) {
        subtypes[el.subtype].push({
          id: el.id,
          ...el.attributes
        });
      }
    }

    if (!preAvailable[el.type] && preAvailableItem) {
      info[el.type] = preAvailableItem.meta;
      preAvailable[el.type] = preAvailableItem.data;
    }
  });

  // ✅ standardowa ścieżka (to co było)
  const available = convertPreAvailable(preAvailable, parameters);

  // ✅ subtype (to co było)
  _forEach(subtypes, (subtype, key) => {
    if (!parameters[key]) {
      parameters[key] = {};
    }
    parameters[key][subtype.id] = subtype;

    if (!selected[key]) {
      selected[key] = getSelectedId(data.relationships, key);
    }

    if (!available[key]) {
      available[key] = subtype;
    }

    const preAvailableItem = data.relationships[`${key}_available`];

    if (preAvailableItem) {
      info[key] = preAvailableItem.meta;
    }
  });

  // ✅ NOWE: fallback dla relacji, które NIE mają included (np. door_*_height, door_*_opening)
  // Budujemy available[...] bezpośrednio z relationships[*_available].data
  _forEach(data.relationships, (rel, relKey) => {
    if (!isAvailableRelationshipKey(relKey)) return;

    const paramName = relKey.replace('_available', '');
    if (!rel || !rel.data) return;

    // jeśli już istnieje (np. standardowe typy z included), nie ruszamy
    if (available[paramName] && Array.isArray(available[paramName]) && available[paramName].length > 0) {
      // ale u Ciebie w przypadku fake potrafi być [{id}] -> wtedy uzupełnij value
      const looksLikeOnlyIds = available[paramName].every((x) => x && x.id && x.value === undefined && x.attributes === undefined);
      if (!looksLikeOnlyIds) return;
    }

    // info zawsze ustawiamy jeśli jest
    if (rel.meta) {
      info[paramName] = rel.meta;
    }

    // selected id (żeby SelectEdit miał co pokazać)
    if (selected[paramName] === undefined || selected[paramName] === null) {
      selected[paramName] = getSelectedId(data.relationships, paramName);
    }

    // Klucz: robimy tablicę {id, value} (tak jak count u Ciebie)
    available[paramName] = (rel.data || []).map((item) => ({
      id: item.id,
      value: `${pickValue(item) ?? ''}`
    }));
  });

  // ✅ colors (to co było)
  available.colors = [
    ...(available.wooden || []),
    ...(available.matt || []),
    ...(available.smooth || [])
  ];

  // ✅ selected + info dla colors (to co było)
  _forEach(colors, (el) => {
    selected[el] = data.relationships[`${el}_selected`] && data.relationships[`${el}_selected`].data.id;
    info[el] = data.relationships[`${el}_available`] && data.relationships[`${el}_available`].meta;
  });

  return {
    parameters,
    available,
    selected,
    info,
    subtypes,
    newData: data.new_data || {},
  };
};

export default convertCalculationResponse;
